import React from "react";
import styled from "styled-components";

const Section = styled.section`
  display: grid;
  grid-template-columns: minmax(0,0.9fr) minmax(0,1.1fr);
  gap: clamp(2rem,6vw,6rem);
  align-items: start;
  padding: clamp(4.5rem,7vw,6.5rem) 8vw;
  @media (max-width: 1024px) { grid-template-columns: 1fr; }
  @media (max-width: 480px) { padding-left: 5vw; padding-right: 5vw; }
`;

const Lead = styled.div`
  p { text-transform: uppercase; letter-spacing: .16em; color: var(--accent-2); font-size: 11px; margin-bottom: 18px; }
  h2 { font-family: "DM Serif Display", serif; font-size: clamp(2.3rem,4vw,4rem); line-height: .98; max-width: 11ch; }
`;

const Body = styled.div`
  display: grid; gap: 28px;
  p { max-width: 58ch; color: var(--ink-78); line-height: 1.9; font-size: 1.02rem; }
`;

const PullQuote = styled.blockquote`
  margin-left: auto; max-width: 32rem;
  padding: 0 0 0 24px;
  border-left: 1px solid rgba(214,179,106,.35);
  color: var(--ink);
  font-family: "DM Serif Display", serif;
  font-size: clamp(1.45rem,2.2vw,2.1rem);
  line-height: 1.35;
`;

const HomeStatement: React.FC = () => (
  <Section>
    <Lead>
      <p>What RMS does</p>
      <h2>Built for records with afterlife, not just release-day noise.</h2>
    </Lead>
    <Body>
      <p>
        RMS sits at the intersection of taste, execution, and rights strategy.
        The work spans original compositions, publishing administration,
        release architecture, and the connective tissue between artists,
        catalogs, and commercial partners. The ambition is simple: build
        music that lands culturally and performs commercially.
      </p>
      <PullQuote>
        "The strongest music companies don't just ship songs. They shape
        context, protect value, and create momentum that compounds."
      </PullQuote>
    </Body>
  </Section>
);

export default HomeStatement;
